/* Akoviya Listicle — keeps the side card next to the article: starts level with the top of the article,
   stays in view while scrolling, and fades out once the reader has passed the last listicle section. */
(function () {
  function init() {
    var rail = document.querySelector('[data-lc-side]');
    if (!rail) return;
    var card = rail.querySelector('.lc-side__card');
    var gap = parseInt(rail.getAttribute('data-top'), 10) || 20;
    function update() {
      if (getComputedStyle(card).position !== 'fixed') return;
      var secs = document.querySelectorAll('.lc-sec');
      var last = secs[secs.length - 1];
      var bar = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--akcd-h'), 10) || 0;
      var top = Math.max(gap + bar, rail.getBoundingClientRect().top);
      var end = last ? last.getBoundingClientRect().bottom : Infinity;
      if (end < top + card.offsetHeight) top = end - card.offsetHeight;
      card.style.top = top + 'px';
      card.classList.toggle('is-off', end < card.offsetHeight * 0.5);
    }
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    if (document.readyState === 'complete') update(); else window.addEventListener('load', update);
    update();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
